module.exports = __webpack_public_path__ + "static/media/padlock.98a1512c.svg";